import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditRfidCardDialogContentComponent } from './edit-rfid-card-dialog-content/edit-rfid-card-dialog-content.component';

@Component({
  selector: 'app-edit-rfid-card-dialog',
  template: ''
})
export class EditRfidCardDialogComponent implements OnInit {

  constructor(public dialog: NgbModal, private activatedRoute: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.openDialog();
  }

  openDialog(): void {
    var isOperatorView = this.activatedRoute.parent.snapshot.data['isOperatorView'];
    var rfidCardId = this.activatedRoute.snapshot.params.key;

    const dialogRef = this.dialog.open(EditRfidCardDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.rfidCardId = rfidCardId;
    dialogRef.componentInstance.customerId = this.activatedRoute.parent.parent.snapshot.params.key;
    dialogRef.componentInstance.isOperatorView = isOperatorView;

    dialogRef.result.then((result) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    });
  }


}
